import { useState } from "react";
import { TextField, Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ForgotPassword = ({
  onCancelForgotPassword,
  onConfirmForgotPassword,
}) => {
  const { t } = useTranslation();
  const [emailForgotPassword, setEmailForgotPassword] = useState("");

  const handleEmailForgotPasswordChange = (event) => {
    setEmailForgotPassword(event.target.value);
  };

  return (
    <Grid
      container
      spacing={2}
      padding="12px"
      marginTop="8px"
      sx={{ backgroundColor: "#ffffffc2", borderRadius: "5%" }}
    >
      <Typography variant="subtitle2" align="center" padding="0 12px">
        {t("login.forgotPasswordExplanation")}
      </Typography>
      <Grid item xs={12}>
        <TextField
          id="email"
          label={t("login.email")}
          value={emailForgotPassword}
          onChange={handleEmailForgotPasswordChange}
          fullWidth
          required
        />
      </Grid>
      <Grid container direction="row" justifyContent="center" marginTop={3}>
        <Button color="primary" onClick={onCancelForgotPassword}>
          {t("login.cancel")}
        </Button>
        <Button
          disabled={!emailForgotPassword}
          variant="contained"
          color="primary"
          onClick={() => onConfirmForgotPassword(emailForgotPassword)}
        >
          {t("login.send")}
        </Button>
      </Grid>
    </Grid>
  );
};
export default ForgotPassword;
